module.exports = __webpack_public_path__ + "img/appImage-customer-base--3.c455f70a.svg";